import { http, HttpResponse } from "msw";

import { OrgData, RbacRole } from "@shared/types";

export const TEST_ORG: OrgData = {
  name: "TestOrg",
  slug: "testorg",
  id: 1,
  has_autofix: false,
  has_deepsemgrep: false,
  has_triage_via_comment: false,
  has_dependency_query: false,
  default_user_role: RbacRole.Admin,
};

export const deploymentHandlersStatic = [
  http.get("*/api/agent/deployments/:id", () =>
    HttpResponse.json(
      {
        deployment: {
          id: TEST_ORG.id,
          name: TEST_ORG.name,
          features: TEST_ORG.features,
          organization_id: TEST_ORG.organization_id,
          source_type: TEST_ORG.source_type,
          default_user_role: TEST_ORG.default_user_role,
        },
      },
      { status: 200 }
    )
  ),
];
